import { useRouter } from '@/router/hooks';
import { useUserActions, useUserInfo } from '@/store/userStore';
import { Button } from '@/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';

/**
 * Account Dropdown
 */
export default function AccountDropdown() {
  const { replace } = useRouter();
  const { full_name, email } = useUserInfo();
  const { clearUserInfoAndToken } = useUserActions();
  const { t } = useTranslation();
  const logout = () => {
    try {
      clearUserInfoAndToken();
    } catch (error) {
      console.log(error);
    } finally {
      replace('/login');
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full">
          <p
            style={{
              height: '25px',
              width: '25px',
              backgroundColor: 'violet',
              textAlign: 'center',
              borderRadius: '999px',
              lineHeight: '25px',
              fontSize: '14px',
            }}
          >
            {(full_name ?? email ?? '').charAt(0)}
          </p>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <div className="flex items-center gap-2 p-2">
          <p
            style={{
              height: '25px',
              width: '25px',
              backgroundColor: 'violet',
              textAlign: 'center',
              borderRadius: '999px',
              lineHeight: '25px',
              fontSize: '14px',
            }}
          >
            {(full_name ?? email ?? '').charAt(0)}
          </p>
          <div className="flex flex-col items-start">
            {full_name ? (
              <div className="text-text-primary text-sm font-medium">{full_name}</div>
            ) : (
              ''
            )}
            <div className="text-text-secondary text-xs">{email}</div>
          </div>
        </div>
        {/* <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <NavLink to="https://docs-admin.slashspaces.com/" target="_blank">
            {t('sys.docs')}
          </NavLink>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <NavLink to="/management/properties">{t('sys.menu.dashboard')}</NavLink>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <NavLink to="/management/user/profile">{t('sys.menu.user.profile')}</NavLink>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <NavLink to="/management/user/account">{t('sys.menu.user.account')}</NavLink>
        </DropdownMenuItem> */}
        <DropdownMenuSeparator />
        <DropdownMenuItem className="font-bold text-warning cursor-pointer" onClick={logout}>
          {t('sys.login.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
